import axiosClient from '../axiosClient';

export const loginWithEmail = (email, password) =>
  axiosClient.post('/auth/login', { email, password });

export const sendOtp = (phone) =>
  axiosClient.post('/auth/send-otp', { phone });

export const verifyOtp = (otpId, otp) =>
  axiosClient.post('/auth/verify-otp', { otpId, otp });

export const getProfile = () =>
  axiosClient.get('/auth/profile');

export const logout = () =>
  axiosClient.post('/auth/logout');
